import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import AdminTasks from "@/components/admin/AdminTasks";
import AdminInvoices from "@/components/admin/AdminInvoices";
import AccountingExport from "@/components/admin/AccountingExport";

/**
 * Hub regroupant les 3 sous-onglets de l'espace Facturation :
 * 1. Extraction (génération de factures BDM à partir des séjours)
 * 2. Factures (liste + import + suivi paiement)
 * 3. Export comptable (CSV / PDF par entité)
 *
 * Le badge "factures non lues" reste géré au niveau supérieur (AdminApp) sur l'onglet
 * "Facturation" lui-même.
 */
export default function AdminBillingHub({ owners, properties, unpaidBadge = 0 }) {
  const [section, setSection] = useState("extraction");

  const sections = [
    { key: "extraction", label: "🧾 Extraction", testid: "admin-billing-sub-extraction" },
    { key: "invoices",   label: "📋 Factures",  testid: "admin-billing-sub-invoices", badge: unpaidBadge },
    { key: "export",     label: "📊 Export comptable", testid: "admin-billing-sub-export" },
  ];

  return (
    <Card data-testid="admin-billing-hub" className="border-white/10 bg-white/[0.08]">
      <CardHeader>
        <CardTitle data-testid="admin-billing-hub-title" className="text-slate-100">Facturation</CardTitle>
        <div data-testid="admin-billing-hub-subtitle" className="text-sm text-slate-300">
          Extraction des prestations, gestion des factures et export comptable par entité.
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap gap-2" role="tablist">
          {sections.map((s) => {
            const active = section === s.key;
            return (
              <Button
                key={s.key}
                data-testid={s.testid}
                variant={active ? "default" : "outline"}
                className={`relative rounded-full ${active ? "bg-violet-500 text-white hover:bg-violet-400" : "border-white/10 bg-white/[0.08] text-slate-100 hover:bg-white/10"}`}
                onClick={() => setSection(s.key)}
              >
                {s.label}
                {s.badge > 0 && (
                  <span
                    data-testid={`${s.testid}-badge`}
                    className="ml-2 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-orange-500 px-1.5 text-[10px] font-bold text-white"
                  >
                    {s.badge > 9 ? "9+" : s.badge}
                  </span>
                )}
              </Button>
            );
          })}
        </div>

        {section === "extraction" && <AdminTasks properties={properties} />}
        {section === "invoices"   && <AdminInvoices owners={owners} properties={properties} />}
        {section === "export"     && <AccountingExport />}
      </CardContent>
    </Card>
  );
}
